import React from 'react';
import { withRouter } from 'react-router-dom';
import { get, sortBy } from 'lodash';
import {
  Grid,
  InputLabel,
  TextField,
  Button,
} from '@mui/material';

import CommentCard from '../common/comment-card';
import {
  repairTicketStatusValues,
} from '../../lib/utils';
import MultiSelect from '../common/multi-select';

const styles = {
  field: {
    marginTop: '15px',
  },
  card: {
    padding: '5px',
    margin: '0 auto',
  },
  cardFooter: {
    display: 'flex',
    marginTop: '15px',
    justifyContent: 'space-between',
  },
  rightPane: {
    marginLeft: '15px',
  },
};

class RepairTicketEditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      newComment: '',
    };

    this.handleChangeNewComment = this.handleChangeNewComment.bind(this);
    this.handleSaveNewComment = this.handleSaveNewComment.bind(this);
    this.selectedStatus = this.selectedStatus.bind(this);
  }

  get comments() {
    const { repairTicket } = this.props;
    const comments = get(repairTicket, 'comments', []);
    const sortedComments = sortBy(comments, (comment) => new Date(comment.date)).reverse();
    return sortedComments;
  }

  get allowCommentSave() {
    const { showCommentSave } = this.state;
    if (showCommentSave) {
      return true;
    } else {
      return false;
    }
  }

  selectedStatus(status) {
    const { repairTicket } = this.props;
    const repairTicketStatus = repairTicket.status;
    return repairTicketStatus === status ? 'contained' : 'outlined';
  }

  handleChangeNewComment(event) {
    this.setState({
      newComment: event.target.value,
      showCommentSave: true,
    });
  }

  handleSaveNewComment() {
    const { newComment } = this.state;
    const { editing, repairTicket } = this.props;
    const comments = get(repairTicket, 'comments', []);

    const userName = localStorage.getItem('userFullName');
    const userId = localStorage.getItem('wranglerId');
    if (newComment) {
      const commentObj = {
        comment: newComment,
        date: new Date(),
        userName,
        userId,
      };
      comments.push(commentObj);
      const newRepairTicket = {
        ...repairTicket,
        comments,
      };
      const commentOnly = true;
      this.props.onSaveComment(newRepairTicket, editing, commentOnly);
    }
  }

  render() {
    const {
      repairTicket,
      handleChange,
      handleButtonEventChange,
      handleVehicleChange,
      editing,
      tz,
    } = this.props;

    const sortedVehicles = sortBy(get(this, 'props.vehicles', []), 'humanId');
    const vehicleOptions = sortedVehicles.map((vehicle) => ({
      value: vehicle._id,
      label: vehicle.humanId,
      isDisabled: false,
    }));

    const { newComment } = this.state;

    return (
      <Grid container>
        <Grid item sm={12}>
          <Grid item style={styles.field}>
            <InputLabel>
              Vehicle
            </InputLabel>
            <MultiSelect
              isDisabled={editing}
              placeholder="Select Vehicle (required)"
              value={[get(repairTicket, 'vehicleId')] || []}
              options={vehicleOptions}
              handleChange={handleVehicleChange}
              isSingle
            />
          </Grid>
          {editing && (
            <Grid item style={styles.field}>
              <InputLabel>
                Status
              </InputLabel>
              <Grid container>
                {repairTicketStatusValues.map((status) => (
                  <Grid item sm={6} key={`status_types_${status}`}>
                    <Button
                      key={`status_types_${status}`}
                      variant={this.selectedStatus(status)}
                      color="primary"
                      name="status"
                      value={status}
                      fullWidth
                      onClick={(event) => handleButtonEventChange(event)}
                    >
                      <div name="status" value={status}>{status}</div>
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </Grid>
          )}
          <Grid item style={styles.field}>
            <InputLabel>
              Description
            </InputLabel>
            <TextField
              fullWidth
              placeholder="Details"
              multiline
              maxRows="10"
              name="description"
              variant="standard"
              value={repairTicket.description || ''}
              onChange={handleChange}
            />
          </Grid>
          {editing
            && (
              <Grid>
                <Grid container style={styles.field}>
                  <InputLabel>
                    Comments
                  </InputLabel>
                  <TextField
                    placeholder="Add a note"
                    multiline
                    fullWidth
                    maxRows="10"
                    variant="standard"
                    value={newComment}
                    onChange={this.handleChangeNewComment}
                  />
                </Grid>
                {this.allowCommentSave
                  && (
                    <Grid container>
                      <Grid item md={12}>
                        <Button
                          size="small"
                          style={styles.field}
                          variant="contained"
                          onClick={this.handleSaveNewComment}
                        >
                          Save
                        </Button>
                      </Grid>
                    </Grid>
                  )}
                {this.comments.map((comment) => (
                  (
                    <CommentCard
                      key={comment.date}
                      classes={styles}
                      comment={comment}
                      user={comment.userName}
                    />
                  )
                ))}
              </Grid>
            )}
        </Grid>
      </Grid>
    );
  }
}

export default withRouter(RepairTicketEditForm);
